<template>
  <div class="card p-3 mb-5 shadow">
    <div style="overflow-x: scroll;">
      <table class="table table-hover table-bordered" :style="'width:' + (400 + calendar.dates.length * 18)  + 'px'">
        <thead>
        <tr>
          <th class="text-center" width="400" style="width: 400px !important;" rowspan="2">Название</th>

          <th v-for="month in calendar.months" :colspan="month.count" :key="month.key"
              style="padding: 5px 0;"
              class="text-center">
            <small class="font-weight-bold">{{ month.title }}</small>
          </th>
        </tr>
        <tr>
          <th v-for="(date, dateKey) in calendar.dates" :key="dateKey"
              style="padding: 5px 0;"
              :class="'text-center ' + (isToDay(date) ? 'table-warning' : '')">
            <small class="font-weight-bold">{{ date.day }}</small>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(prescription, prescriptionKey) in prescriptions" :key="prescriptionKey">
          <td width="400" style="width: 400px !important;" class="text-nowrap">
            {{ prescription.name }}

            <small class="text-muted">
              {{prescription.manufacturer}}
            </small>

            <small class="d-block text-muted">
              {{ prescription.quantity }};
              {{ prescription.times }};
              {{ prescription.methods }}
            </small>
          </td>

          <td v-for="(date, dateKey) in calendar.dates"
              :key="dateKey"
              style="padding:0;"
              class="position-relative"
              :title="`${date.string}.\n${prescription.name}.\nНазначен: ${prescription.prescribed}.\nПрием: ${prescription.taken}`">
            <div style="width:18px;" class="text-center m-0"></div>

            <div
                style="top:50%;left:50%;margin-left:-3px;margin-top:-3px;width:7px;height:7px;"
                :class="'rounded-circle position-absolute' + (showDotBg(prescription, date) ? ' bg-primary' : '') + (showDotBorder(prescription, date) ? ' border border-secondary' : '')"
                v-if="showDot(prescription, date)">
              &nbsp;
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import formatDate from '../../utils/formatDate';
  import declensionNumbers from '../../utils/declensionNumbers';
  import calculateDaysCount from '../../utils/calculateDaysCount';
  import {FORMAT_NAMES, MS_IN_DAY} from '../../constants';

  export default {
    props: ['drugPrescriptions'],

    data() {
      return {
        today: formatDate(new Date(), 'ymd'),
        monthNames: [
          'Январь',
          'Февраль',
          'Март',
          'Апрель',
          'Май',
          'Июнь',
          'Июль',
          'Август',
          'Сентябрь',
          'Октябрь',
          'Ноябрь',
          'Декабрь',
        ],
      };
    },

    computed: {
      prescriptions() {
        return this.drugPrescriptions.map(item => {
          const formatName = FORMAT_NAMES.find(i => i[0] === item.drug.format.name);
          const [, few, one, two ] = formatName || [name, name, name, name];
          const quantityMeasure = declensionNumbers(item.quantity, few, one, two);
          const startDate = new Date(item.startDate);
          const finishDate = new Date(item.finishDate);
          const result = {
            name: `${item.drug.name} ${item.drug.measure || ''} ${item.drug.measureUnit || ''}`,
            manufacturer: item.drug.manufacturer ? item.drug.manufacturer.name : '',
            quantity: `${item.quantity} ${quantityMeasure}`,
            times: item.times.map(time => time.name).join(', '),
            methods: item.methods.map(method => method.name).join(', '),
            prescribed: `${formatDate(startDate, 'd.m.y')} - ${formatDate(finishDate, 'd.m.y')}`,
            taken: 'не начат',
            from: formatDate(startDate, 'ymd'),
            to: formatDate(finishDate, 'ymd'),
            start: 0,
            finish: 0,
          };

          if(item.startedAt) {
            const duration = calculateDaysCount(item.startDate, item.finishDate);
            const startedAt = new Date(item.startedAt);
            const finishedAt = new Date(item.startedAt);

            finishedAt.setDate(finishedAt.getDate() + duration);

            result.start = formatDate(startedAt, 'ymd');
            result.finish = formatDate(finishedAt, 'ymd');
            result.taken = `${formatDate(startedAt, 'd.m.y')} - ${formatDate(finishedAt, 'd.m.y')}`;
          }

          return result;
        });
      },

      calendar() {
        const dates = [];
        const months = {};
        const timestamps = { from: Date.now(), to: Date.now() };

        for(const prescription of this.drugPrescriptions) {
          const timestampFrom = new Date(prescription.startDate).getTime();
          const timestampTo = new Date(prescription.finishDate).getTime();

          timestamps.from = timestamps.from > timestampFrom ? timestampFrom : timestamps.from;
          timestamps.to = timestamps.to < timestampTo ? timestampTo : timestamps.to;
        }

        for (let i = timestamps.from, it = timestamps.to + MS_IN_DAY; i <= it; i += MS_IN_DAY) {
          const date = new Date(i);
          const key = `${date.getFullYear()}-${date.getMonth()}`;
          const title = `${this.monthNames[date.getMonth()]} ${date.getFullYear()}`;

          if (typeof months[key] === 'undefined') {
            months[key] = { key, title, count: 0 };
          }

          dates.push({
            day: date.getDate(),
            string: formatDate(date, 'd.m.y'),
            date: formatDate(date, 'ymd')
          });

          months[key].count++;
        }

        return {
          months: Object.values(months),
          dates
        };
      },
    },

    methods: {
      isToDay(date) {
        return this.today === date.date;
      },

      showDot(prescription, date) {
        return date.date >= prescription.from && (date.date <= prescription.to || date.date <= prescription.finish);
      },

      showDotBorder(prescription, date) {
        return date.date >= prescription.from && date.date <= prescription.to;
      },

      showDotBg(prescription, date) {
        return date.date >= prescription.start && date.date <= prescription.finish;
      },
    },
  };
</script>
